import React from 'react';
import { motion } from 'motion/react';
import { useLanguage } from '../context/LanguageContext';
import { Briefcase } from 'lucide-react';

const Experience = () => {
  const { t } = useLanguage();

  const experiences = t('experience.items');

  return (
    <section id="experience" className="py-24 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-display font-black mb-4 tracking-tight">
            {t('experience.title')}
          </h2>
          <div className="w-20 h-1 bg-secondary mx-auto rounded-full" />
        </motion.div>

        <div className="relative max-w-4xl mx-auto">
          {/* Vertical Line */}
          <div className="absolute left-0 md:left-1/2 top-0 bottom-0 w-1 bg-gradient-to-b from-primary via-secondary to-accent opacity-30 -translate-x-1/2" />

          <div className="space-y-16">
            {experiences.map((exp: any, idx: number) => (
              <motion.div
                key={idx}
                initial={{ opacity: 0, x: idx % 2 === 0 ? -50 : 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8 }}
                className={`relative flex flex-col md:flex-row items-center gap-8 ${
                  idx % 2 === 0 ? 'md:flex-row-reverse' : ''
                }`}
              >
                {/* Dot */}
                <div className="absolute left-0 md:left-1/2 w-6 h-6 rounded-full bg-bg-dark border-4 border-primary -translate-x-1/2 z-10 shadow-[0_0_15px_rgba(0,242,255,0.8)]" />

                {/* Content */}
                <div className="w-full md:w-1/2 pl-10 md:pl-0">
                  <div className="p-8 glass rounded-3xl group hover:border-primary/30 transition-all text-left">
                    <div className="flex items-center gap-3 mb-4">
                      <div className="w-12 h-12 rounded-2xl bg-secondary/10 flex items-center justify-center group-hover:bg-secondary/20 transition-colors">
                        <Briefcase className="w-6 h-6 text-secondary" />
                      </div>
                      <div>
                        <h3 className="text-xl font-display font-bold text-white/90">{exp.company}</h3>
                        <p className="text-sm font-mono text-primary font-bold">{exp.period}</p>
                      </div>
                    </div>
                    <ul className="text-white/60 leading-relaxed space-y-2 list-disc list-outside ml-4">
                      {Array.isArray(exp.description) ? (
                        exp.description.map((line: string, index: number) => (
                          <li key={index} className="text-sm">{line}</li>
                        ))
                      ) : (
                        <li className="text-sm">{exp.description}</li>
                      )}
                    </ul>
                  </div>
                </div>

                {/* Spacer for the other side */}
                <div className="hidden md:block w-1/2" />
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
